import TextSelector from 'components/Common/TextSelector';
import createMarkup from 'components/Dashboard/helpers/createMarkup';
import DateReplacements from 'components/Dashboard/UpcomingEvents/DatesReplacements';
import { OrderCategories } from 'components/Dashboard/UpcomingEvents/EventsHierarchy';
import React, { useMemo } from 'react';
import time from 'utils/time';

const UpcomingEventDashboardUpdate = ({ content, scrolling, scrollbarRef }) => {
  const { eventCategory, subject, description } = content;
  const { title } = eventCategory ?? {};
  const categoriesToShow = OrderCategories([title]);
  const [commonCategoriesToShow, lordsCategoriesToShow, announcementsCategoriesToShow] = categoriesToShow;
  const categoriesMapping = {
    commons: commonCategoriesToShow,
    lords: lordsCategoriesToShow,
    announcements: announcementsCategoriesToShow,
  };
  const mainCategory = Object.keys(categoriesMapping).find(
    (key) => categoriesMapping[key].length > 0 && categoriesMapping[key].includes(title)
  );

  const descriptionContent = useMemo(() => {
    if (!description) return null;
    return <div className='paragraph-p1' dangerouslySetInnerHTML={createMarkup(description)}></div>;
  }, [description]);

  return (
    <div className='pt-4 pb-3 specific-x-padding-28'>
      <h5 className={`calendar-category calendar-category-${mainCategory} border-none paragraph-p2`}>{title}</h5>
      <h5 className='title-h5 font-weight-bold specific-bottom-margin-28'>{subject}</h5>
      <TextSelector
        currentNew={content}
        scrollbarRef={scrollbarRef}
        scrolling={scrolling}
        hideCreateReportButton={true}
      >
        {descriptionContent}
      </TextSelector>
    </div>
  );
};

const UpcomingEventDashboardUpdateTitle = ({ content }) => {
  const { startDateTime } = content;
  const dateToShow = (date) => {
    let dateReplacement = DateReplacements(date);
    if (dateReplacement === null) {
      return `${time(time.getCalendarDateKey(date)).formatWeekdayShortDate()}`;
    } else {
      return dateReplacement;
    }
  };
  return (
    <>
      <h3 className='main-title mb-0 hidden-lines hidden-one-line title-h5 d-flex align-items-center gap-30 specific-top-padding-1'>
        <div className='d-flex align-items-center'>
          <span className='icon-calendar specific-right-margin-12 title-h2' />
          <span>{dateToShow(startDateTime)}</span>
        </div>
        <div className='d-flex align-items-center'>
          <span className='icon-clock specific-right-margin-12 title-h2' />
          <span>{time(startDateTime).format('h:mm A')}</span>
        </div>
      </h3>
    </>
  );
};
export { UpcomingEventDashboardUpdateTitle };
export default UpcomingEventDashboardUpdate;
